import {Col, Row} from "antd";
import DistanceComponent from "./DistanceComponent";
import TrackMap from "./TrackMap";
import React, {useState} from "react";


interface IMapPage {
    showMap: boolean
    autoCenter: boolean
    showIphone: boolean
    comp: number
}

export default function MapPage(props: IMapPage) {
    const [distance, setDistance] = useState<number | null>(null)

    function setDistanceHandler(distance: number| null) {
        setDistance(distance)
    }

    return(
        <Row>
            <Col lg={{ span: 7 }} xl={{ span: 7 }} xxl={{ span: 7 }} offset={1}>
                <DistanceComponent distance={distance}/>
            </Col>
            <Col lg={{ span: 8, offset: 8 }} xl={{ span: 8, offset: 8 }} xxl={{ span: 8, offset: 8 }}>
                <TrackMap
                    showMap={props.showMap}
                    setDistanceHandler={setDistanceHandler}
                    autoCenter={props.autoCenter}
                    showIphone={props.showIphone}
                    comp={props.comp}
                />
            </Col>
        </Row>
    )
}